import BaseAPI from '@/apis/base/baseApi';

class WebsiteWideTaskResultAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'websiteWideTaskResult';
}

export default new WebsiteWideTaskResultAPI();
